import React, {memo} from 'react';
import theme from './style';
import {connect} from 'react-redux';
import PropTypes from 'prop-types';
import {bindActionCreators} from 'redux';
import {BorderButton,} from '../../components/buttons'
import {Grid} from '@material-ui/core';
import {useParams, withRouter} from "react-router-dom";
import Label from '../../components/label'
import {setFormData, initiateBankAuth, stopBankIdAuthProccess} from '../../redux/actions/login';
import translate from '../../misc/applyTranslation'
import APICall from "../../misc/APICall";
import {useConfig} from "../../context/configContext";

const AuthBankID = (props) => {
  const config = useConfig();
  const classes = theme(config);
  const params = useParams();
  const { lang } = params
  const {bankAuthInit, stopBankIdAuthProccess, abortedBankIdProccess} = props;

  const handleCancel = (e) => {
    try {
      e.preventDefault();
    } catch (error) {
    }
    stopBankIdAuthProccess()
  }

  const initiateHostedBankAuth = () => {
    let formData = new FormData();
    formData.append("lang", lang);
    APICall({
      url: 'begin_hosted_login_procedure',
      verb: "post",
      body: formData
    })
      .then(res => {
        if (res) {
          window.location = res.redirectUrl
        }
      })
  };

/*  useEffect(() => {

    if (config.bankid_use_hosted_login === "true" && history.location.pathname === "/"+lang) {
      //initiateHostedBankAuth();
    }
  }, []);*/

  let notRunningProcess = !bankAuthInit || (bankAuthInit && abortedBankIdProccess);
  return (
    <form onSubmit={(e) => e.preventDefault()} className={classes.formContainer}>
      <Grid container className={'gridContainer'}>
        <React.Fragment>
          <Grid item xs={11} sm={9} md={7} lg={5} className={'gridItemContainer'}>

            {notRunningProcess &&
            <div className={'inputGroup'}>
              <BorderButton type='submit' text={translate('login', 'button_login_bankid')} onClick={initiateHostedBankAuth}/>
              <Label text={translate('', 'login_text')}/>
            </div>
            }
            {!notRunningProcess &&
            <div className={'inputGroup'} style={{textAlign: 'center'}}>
              <Label text={translate('login', 'label_bankid_auth_proccess_running')}/>
              <BorderButton type='submit' text={translate('', 'button_cancel')} onClick={handleCancel}/>
            </div>
            }

          </Grid>

        </React.Fragment>
      </Grid>
    </form>
  )
}
AuthBankID.propTypes = {
  setFormData: PropTypes.func.isRequired,
  initiateBankAuth: PropTypes.func.isRequired,
  ssn: PropTypes.string.isRequired,
  bankAuthInit: PropTypes.string.isRequired,
}
const mapStateToProps = store => ({
  ssn: store.login.ssn,
  bankAuthInit: store.login.bankAuthInit,
  abortedBankIdProccess: store.login.abortedBankIdProccess

});
const mapDispatchToProps = dispatch =>
  bindActionCreators({
    setFormData,
    initiateBankAuth,
    stopBankIdAuthProccess
  }, dispatch);
export default connect(mapStateToProps, mapDispatchToProps)(withRouter(memo(AuthBankID)));
